var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{staticClass:"appContainer appgrid px-0 pt-0",attrs:{"fluid":""}},[_c('AppNavigation'),_c('v-main',{staticClass:"mainContent"},[_c('router-view')],1),_c('div',{staticClass:"appFooter"})],1),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }